<template>
  <div>
    <Dialog
      width="684px"
      :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
      :customClass="`${createRenderType}-reason-dialog reason-dialog`"
      :backgroundImage="false"
      titleAlign="left"
      :visible="dialogVisible"
      :title="$t('credit.cancel_subscription')"
      @close="onClose"
    >
      <div class="flex-column flex1 total-box">
        <div class="reason-box">
          <div class="text">{{ $t("credit.tell_us_why") }}</div>
          <div class="reason-list">
            <div
              class="item flex-row-center pointer"
              v-for="item in reasonList"
              :key="item"
              @click="selectReason(item.value)"
            >
              <img
                v-if="selectedList.includes(item.value)"
                src="@/assets/img/credit/selected.png"
                alt=""
              />
              <img v-else src="@/assets/img/credit/no-select.png" alt="" />
              <div>{{ $t(item.label) }}</div>
            </div>
          </div>
        </div>
        <div class="reson-input">
          <el-input
            type="textarea"
            :placeholder="$t('credit.please_specify')"
            resize="none"
            v-model="reason"
          ></el-input>
        </div>
        <div class="btn-group flex-space-between">
          <div class="flex-center using" @click="handleKeepUsing">
            {{ $t("credit.continue_using") }}
          </div>
          <div
            :class="{
              'flex-center': true,
              cancel: true,
              using: isUsing,
            }"
            @click="handleCancelSubscribe"
          >
            {{ $t("credit.unsubscribe") }}
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  getCurrentInstance,
  defineProps,
  defineEmits,
  onMounted,
} from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { feedbackSubscriptionCancel } from "@/api/api/apiCredit.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const emits = defineEmits(["update:visible", "update:cancelReasonList", "confirmCancel"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  manageUrl: {
    type: String,
    default: "",
  },
  cancelReasonList: {
    type: Object,
    default: () => {},
  },
});
const reasonList = ref([
  {
    label: "credit.cancelReason1",
    value: "low_quality",
  },
  {
    label: "credit.cancelReason2",
    value: "no_follow_input",
  },
  {
    label: "credit.cancelReason3",
    value: "difficult_use",
  },
  {
    label: "credit.cancelReason4",
    value: "expensive",
  },
  {
    label: "credit.cancelReason5",
    value: "better_option",
  },
  {
    label: "credit.cancelReason6",
    value: "copyright",
  },
  {
    label: "credit.cancelReason7",
    value: "technical",
  },
  {
    label: "credit.cancelReason8",
    value: "support_issue",
  },
  {
    label: "credit.cancelReason9",
    value: "[other]",
  },
]);
const reason = ref("");
const selectedList = ref([]);
const dialogVisible = ref(props.visible);
const isUsing = ref(false);

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

watch(
  selectedList,
  (val) => {
    if (val.includes("[other]")) {
      isUsing.value = !!reason.value;
    } else {
      isUsing.value = !!val.length;
    }
  },
  { deep: true }
);

watch(
  reason,
  (val) => {
    const index = selectedList.value.indexOf("[other]");
    if (val) {
      if (index == -1) {
        selectedList.value.push("[other]");
      } else {
        isUsing.value = true;
      }
    } else {
      if (index > -1) {
        isUsing.value = false;
      }
    }
  },
  { deep: true }
);

const selectReason = (value) => {
  const index = selectedList.value.indexOf(value);
  if (index > -1) {
    selectedList.value.splice(index, 1);
  } else {
    selectedList.value.push(value);
  }
};

const handleKeepUsing = () => {
  globalProperties.logClickEvent("cancelsubscription_continueusing");
  emits("update:visible", false);
};

const handleCancelSubscribe = () => {
  if (isUsing.value) {
    globalProperties.logClickEvent("cancelsubscription_cancelsubscription", {
      reason: selectedList.value
        .map((item) => {
          const index = reasonList.value.findIndex(
            (reason) => reason.value === item
          );
          return index !== -1 ? index + 1 : null;
        })
        .filter((item) => item !== null)
        .join(","),
      specifyresons: reason.value,
    });
    const list = selectedList.value.map((item) =>
      item === "[other]" ? `[other]${reason.value}` : item
    );
    emits("update:cancelReasonList", list);
    emits("update:visible", false);
    emits("confirmCancel");
    // feedbackSubscriptionCancel({
    //   reasons: list,
    // }).then((res) => {
    //   if (res.code == 200) {
    //     emits("update:visible", false);
    //     emits("confirmCancel");
    //     // window.location.href = props.manageUrl
    //   }
    // });
  }
};

onMounted(() => {
  globalProperties.logViewEvent("cancelsubscription");
});
</script>


<style lang="scss">
.mobile-reason-dialog {
  .dialog-content {
    display: flex;
    // flex-direction: column;
  }
}
</style>
<style lang="scss" scoped>
.pc-reason-dialog {
  .reason-box {
    padding: 0 40px;
    color: #fff;
    .text {
      margin-top: 2px;
      font-size: 14px;
      line-height: 20px;
      opacity: 0.5;
    }
    .reason-list {
      margin-top: 21px;
      margin-bottom: 7px;
      .item {
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .reson-input {
    height: 100px;
    margin: 7px 40px 0;
    :deep(.el-textarea) {
      height: 100%;
      textarea {
        height: 100%;
        padding: 8px 11px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        box-shadow: none;
        color: #fff;
        &::placeholder {
          color: rgba(255, 255, 255, 0.5) !important;
        }
      }
    }
  }
  .btn-group {
    margin: 20px 40px 40px;
    div {
      height: 48px;
      width: 296px;
      border-radius: 62px;
    }
    .cancel {
      background: rgba(255, 255, 255, 0.2);
      color: rgba(255, 255, 255, 0.5);
    }
    .using {
      background: linear-gradient(99deg, #4fdeff 0%, #e675ff 100%);
      cursor: pointer;
      color: #000;
    }
  }
}
.mobile-reason-dialog {
  .total-box {
    padding: 0 20px;
    width: 0;
  }
  .reason-box {
    color: #fff;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    .text {
      margin-top: 2px;
      font-size: 14px;
      line-height: 20px;
      opacity: 0.5;
    }
    .reason-list {
      flex: 1;
      height: 0;
      overflow-y: auto;
      margin-top: 21px;
      margin-bottom: 7px;
      .item {
        margin-bottom: 15px;
        font-size: 14px;
        // font-weight: 500;
        line-height: 18px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .reson-input {
    flex-shrink: 0;
    height: 80px;
    margin: 7px 0 0;
    :deep(.el-textarea) {
      height: 100%;
      textarea {
        height: 100%;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        box-shadow: none;
        color: #fff;
        padding: 8px 11px;
        &::placeholder {
          color: rgba(255, 255, 255, 0.5) !important;
        }
      }
    }
  }
  .btn-group {
    margin: 20px 0px 28px;
    div {
      font-size: 14px;
      height: 48px;
      width: calc((100% - 8px) / 2);
      border-radius: 62px;
    }
    .cancel {
      background: rgba(255, 255, 255, 0.2);
      color: rgba(255, 255, 255, 0.5);
    }
    .using {
      background: linear-gradient(99deg, #4fdeff 0%, #e675ff 100%);
      cursor: pointer;
      color: #000;
    }
  }
}
</style>